module.exports = __webpack_public_path__ + "static/img/excel.327c7de.png";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/excel.png
// module id = jnS2
// module chunks = 4